import { apiPost } from '../api.utils'
import type { IResponseCommon } from '../common.types'

export type RegistrationAddressComponents = Partial<Record<'region' | 'district' | 'city' | 'locality' | 'street' | 'house' | 'building' | 'apartment' | 'postalCode', string>>
export type RecognizedAddress = { query: string; components: RegistrationAddressComponents }
export type NormalizedAddressResponse = IResponseCommon & { data?: {
    normalizedAddress: string | null
    reason: 'normalized' | 'ambiguous' | 'not_found' | 'missing_postal_code' | 'incomplete' | 'unavailable'
    suggestions: { value: string; postalCode: string | null }[]
    error?: string
} }

export const normalizeRecognizedListenerAddress = (address: RecognizedAddress, signal?: AbortSignal) =>
    apiPost<NormalizedAddressResponse>('/listeners/getListenerAddressSuggestions', { signal }, { ...address, recognition: true })
